function normalizeHeaderSearchTerm(value) {
	if (typeof value !== 'string') return '';
	return value.replace(/\u00A0/g, ' ').replace(/&nbsp;?/gi, ' ').trim();
}

function normalizeHeaderSearchTermForSubmit(value) {
	const normalized = normalizeHeaderSearchTerm(value);
	return normalized === '' ? '*' : normalized;
}

document.addEventListener('DOMContentLoaded', function () {

	document.querySelectorAll('form[role="search"]').forEach(function (form) {
		const searchInput = form.querySelector('input[name="q"]');
		if (!searchInput) return;

		form.addEventListener('submit', function () {
			searchInput.value = normalizeHeaderSearchTermForSubmit(searchInput.value);
		});
	});
});
